<template>
  <div
    class="TimelineMenu"
    :class="{ 'open': isOpen }"
  >
    <Popover
      trigger="click"
      :bound-to="{ x: 'container' }"
      bound-to-selector=".Timeline"
      :margin="{ left: 8, right: 8 }"
      popover-class="timeline-menu-popover popover-default"
      @show="openMenu"
      @close="() => isOpen = false"
    >
      <template #content>
        <FeedMenu pinnable />
      </template>
      <template #trigger>
        <span class="button-unstyled timeline-menu-title">
          <h1 class="title timeline-title">{{ timelineName }}</h1>
          <span>
            <FAIcon
              size="sm"
              icon="chevron-down"
            />
          </span>
        </span>
      </template>
    </Popover>
  </div>
</template>

<script src="./timeline_menu.js"></script>

<style lang="scss">
.timeline-menu-popover {
  min-width: 24rem;
  max-width: 100vw;
  margin-top: 0.6rem;
  font-size: 1rem;
  border-top-right-radius: 0;
  border-top-left-radius: 0;

  /* the list scrolls, not the pop-up: its outline sticks out by 1px */
  .FeedMenu {
    max-height: calc(100vh - var(--navbar-height) - 5em);
    overflow-y: auto;
  }
}

.TimelineMenu {
  /* fills its grid cell (an auto margin would size it to its content and
     let a long name run over the header) */
  display: flex;
  gap: 0.75em;
  min-width: 0;

  /* a long name ends in an ellipsis */
  > .popover-wrapper,
  .popover-trigger-button,
  .timeline-title {
    min-width: 0;
  }

  .popover-trigger-button {
    display: flex;
    max-width: 100%;
  }

  .panel::after {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }

  .timeline-menu-title {
    margin: 0;
    cursor: pointer;
    user-select: none;
    width: 100%;
    display: flex;

    svg {
      margin-left: 0.6em;
      transition: transform 100ms;
    }
  }

  &.open .timeline-menu-title svg {
    transform: rotate(180deg);
  }
}
</style>
